import {
  Button,
  Form,
  message,
  Modal,
  Row,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";
import "./ChangePassword.css";
import { postChangePassword } from "../../../store/thunks/common-thunks/commonThunk";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../store/slices/auth/LoginSlice";
import { RESET_USER } from "../../../store/slices/auth/UserProfileSlice";
import { nanoid } from "nanoid";
import { useNavigate } from "react-router-dom";
import FloatingInput from "../../common/float-input/FloatInput";
const Text = Typography;
const ChangePassword = ({ changePasswordModal, setChangePasswordModal }) => {
  const [form] = Form.useForm();
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const { user } = storedUser;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleClose = () => {
    form.resetFields();
    setChangePasswordModal(false);
  };
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
    "--label-margin-top": "-6px",
  };
  const { requestStatus, isLoading } = useSelector(
    (state) => state.userprofile
  );
  const isPasswordLoading = isLoading && requestStatus === "changePassword";
  const passwordRules = [
    { required: true, message: "New Password is required!" },
    {
      pattern:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      message: "Password must be at least 8 characters long !",
    },
  ];

  const handleSubmit = async (values) => {
    const payload = {
      password: values.password,
      newPassword: values.newPassword,
      confirmNewPassword: values.confirmNewPassword,
    };
    const res = await dispatch(postChangePassword(payload));
    if (res?.payload?.status === 1) {
      message.success(res.payload.message, 5);
      localStorage.clear();
      await dispatch(logout());
      dispatch(RESET_USER());
      sessionStorage.setItem("sessionId", nanoid());
      form.resetFields();
      setChangePasswordModal(false);
      navigate("/login");
    }
  };

  return (
    <div>
      <Modal
        open={changePasswordModal}
        onCancel={handleClose}
        footer={null}
        centered
        maskClosable={false}
      >
        <Row>
          <Text className="change-password-title">Change Your Password</Text>
        </Row>
        <Row>
          <Text className="create-password-sh">
            Keep your account secure with a new password
          </Text>
        </Row>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          className="create-password-form"
          style={{ marginTop: "20px" }}
        >
          {/* current Password */}
          <Row justify="center">
            <Form.Item
              name="password"
              rules={[
                { required: true, message: "Old Password is required!" },
                {
                  pattern:
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                  message: "Please enter your old password",
                },
              ]}
              style={{ width: "90%" }}
            >
              <FloatingInput
                className="billboard-input-feild reset-password-fields billboard-password-field"
                label={<>{`Old Password `}</>}
                isPassword={true}
                customStyles={floatingInputStyles}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    form.submit();
                  }
                }}
              />
            </Form.Item>
          </Row>

          {/* New Password */}
          <Row justify="center">
            <Form.Item
              name="newPassword"
              rules={passwordRules}
              style={{ width: "90%" }}
            >
              <FloatingInput
                className="billboard-input-feild reset-password-fields billboard-password-field"
                label={<>{`New Password `}</>}
                isPassword={true}
                customStyles={floatingInputStyles}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    form.submit();
                  }
                }}
              />
            </Form.Item>
          </Row>

          {/* Confirm Password */}
          <Row justify="center">
            <Form.Item
              name="confirmNewPassword"
              dependencies={["newPassword"]}
              rules={[
                {
                  required: true,
                  message: "Please confirm your new password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("newPassword") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Passwords do not match!"));
                  },
                }),
              ]}
              style={{ width: "90%" }}
            >
              <FloatingInput
                className="billboard-input-feild billboard-password-field"
                label={<>{`Confirm Password`}</>}
                isPassword={true}
                customStyles={floatingInputStyles}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    form.submit();
                  }
                }}
              />
            </Form.Item>
          </Row>

          {/* Password Guidelines */}
          <Row justify="center" className="restrictions-row">
            <div className="validation-container">
              <ul>
                <li className="validation-container-text">
                  Use 8+ characters with a mix of uppercase, lowercase, numbers,
                  and symbols.
                </li>
                <li className="validation-container-text">
                  Avoid common words or easily guessed phrases.
                </li>
                <li className="validation-container-text">
                  Don't reuse old passwords for extra security.
                </li>
              </ul>
            </div>
          </Row>

          {/* Submit Button */}
          <Row className="restrictions-row" justify="center">
            <Button
              type="primary"
              htmlType="submit"
              className="reset-new-button billboard-button-2"
              loading={isPasswordLoading}
              style={{ marginLeft: "0px" }}
            >
              {isPasswordLoading ? "Resetting..." : "Reset Password"}
            </Button>
          </Row>
          <Row align="middle" justify="center" style={{ marginTop: 20 }}>
            <Text
              className="forgot-password"
              onClick={() => {
                form.resetFields();
                setChangePasswordModal(false);
              }}
            >
              {user?.email ? "Back" : "Back to Login"}
            </Text>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};
export default ChangePassword;
